import { v4 as uuidv4 } from 'uuid';
import { dispatch, resolveEvent } from './ui-message-handler';

export const getClientStorage = async (name) => {
  const id = uuidv4();
  dispatch('getClientStorage', { name, id });
  return resolveEvent(`clientStorageResponse-${id}`);
};

export const setClientStorage = (name, value) => {
  dispatch('setClientStorage', { name, data: value });
};
